import { roleOf } from "@/lib/roles";

const PRI = { fields: 0, relay: 1, cover: 2, backup: 3, hold: 4 };

export const labelDims = (label, size) => {
  const ls = size * 0.66;
  return { ls, w: Math.max(label.length * ls * 0.56 + ls, size * 2), h: ls * 1.44 };
};

const overlap = (a, b) =>
  Math.max(0, Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x)) *
  Math.max(0, Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y));

export function layoutLabels(players, size, bounds) {
  const list = Object.values(players).map((p) => ({ ...p, X: p.pt[0], Y: -p.pt[1] }));
  const r = size * 1.16;
  const circles = list.map((p) => ({ pos: p.pos, x: p.X - r, y: p.Y - r, w: r * 2, h: r * 2 }));
  list.sort((a, b) => PRI[roleOf(a.job)] - PRI[roleOf(b.job)]);
  const placed = [];
  const out = {};
  list.forEach((p) => {
    const { w, h, ls } = labelDims(p.label, size);
    const d = r + ls * 0.75;
    const sx = r + w / 2;
    const cands = [
      [0, d], [0, -d], [sx, 0], [-sx, 0], [sx * 0.8, d * 0.85], [-sx * 0.8, d * 0.85],
      [sx * 0.8, -d * 0.85], [-sx * 0.8, -d * 0.85], [0, d + h * 1.1], [0, -(d + h * 1.1)],
    ];
    let best = cands[0];
    let bestScore = Infinity;
    for (const [dx, dy] of cands) {
      const rect = { x: p.X + dx - w / 2, y: p.Y + dy - h / 2, w, h };
      const outside = rect.w * rect.h - overlap(rect, bounds);
      const score = outside * 3 +
        placed.reduce((s, q) => s + overlap(rect, q), 0) +
        circles.reduce((s, c) => (c.pos === p.pos ? s : s + overlap(rect, c)), 0);
      if (score < bestScore - 0.01) {
        best = [dx, dy];
        bestScore = score;
      }
      if (score === 0) break;
    }
    placed.push({ x: p.X + best[0] - w / 2, y: p.Y + best[1] - h / 2, w, h });
    out[p.pos] = best;
  });
  return out;
}
